import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  useGetWorkOrderData,
  usePutAdminCloseWorkOrder,
  usePutAdminUpdateWorkOrder,
  usePutScanEmployeeUpdateWorkOrder,
} from "../../hooks";
import { ConfirmWorkOrderStation } from "../../dialogs";
import { PageContent } from "../../components";

import WorkOrderSkeleton from "./WorkOrderSkeleton";
import WorkOrderContent from "./WorkOrderContent";

const WorkOrderDetails = () => {
  const { id } = useParams();

  const { data, isLoading, isError } = useGetWorkOrderData(id);

  const { mutate: putAdminUpdateWorkOrder, isSuccess: isUpdateSuccess } =
    usePutAdminUpdateWorkOrder();
  const {
    mutate: putScanEmployeeUpdateWorkOrder,
    isSuccess: isScanUpdateSuccess,
  } = usePutScanEmployeeUpdateWorkOrder();
  const { mutate: putAdminCloseWorkOrder, isSuccess: isCloseSuccess } =
    usePutAdminCloseWorkOrder();

  const [payload, setPayload] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [useScanEndpoint, setUseScanEndpoint] = useState(false);

  const isSuccess = isUpdateSuccess || isCloseSuccess || isScanUpdateSuccess;

  useEffect(() => {
    if (isSuccess) {
      setPayload(null);
      setIsClosing(false);
      window.location.reload();
    }
  }, [isSuccess]);

  const handleCloseWorkOrder = () => {
    setIsClosing(true);
    setPayload(true);
  };

  const onSubmit = (putPayload) => {
    if (isClosing) putAdminCloseWorkOrder({ id, ...putPayload });
    else if (useScanEndpoint) putScanEmployeeUpdateWorkOrder(putPayload);
    else putAdminUpdateWorkOrder(putPayload);
  };

  const onClose = () => setPayload(null);

  return (
    <PageContent
      gap="15px"
      isLoading={isLoading}
      isError={isError}
      skeleton={<WorkOrderSkeleton />}
      disablePadding
    >
      {data && (
        <WorkOrderContent
          id={id}
          data={data}
          setPayload={setPayload}
          handleCloseWorkOrder={handleCloseWorkOrder}
          setUseScanEndpoint={setUseScanEndpoint}
        />
      )}
      <ConfirmWorkOrderStation
        isOpen={!!payload}
        isClosing={isClosing}
        onClose={onClose}
        onSubmit={onSubmit}
        payload={payload}
        data={data}
      />
    </PageContent>
  );
};

export { WorkOrderDetails };
export default WorkOrderDetails;
